import type {PosterPageData} from '@Libraries/poster-library';
import type {OpenDesignSelectorOptions} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/email-maker-plugin.types';
import {noop} from '@Utils/general.util';
import styles from '@Components/design-selector/design-selector.module.scss';

const DESIGN_SELECTOR_PAGES_LIMIT = 5;

/** Thin opts builder over the `PMW.designSelector` coordinator, which owns selection state and all DOM visuals. */
export function openDesignSelector(onDesignLoaded: (data: PosterPageData[]) => void, options: OpenDesignSelectorOptions = {}): void {
  const {beforeLoad = noop, isMultiselectAllowed = true, addCheckmarkOnSelection = true, showPageLimitWarning = true} = options;
  window.PMW.util.require(typeof window.PMW.designSelector === 'undefined', 'designSelector', true, () => {
    beforeLoad();
    window.PMW.designSelector.open({
      title: window.i18next.t('pmwjs_select_a_design'),
      isMultiSelectionAllowed: isMultiselectAllowed,
      addCheckmarkOnSelection,
      selectedNameClass: styles.selectedName,
      pageLimitBanner:
        showPageLimitWarning && isMultiselectAllowed
          ? {
              threshold: DESIGN_SELECTOR_PAGES_LIMIT,
              desktopMessageKey: 'pmwjs_email_editor_page_limit_message_desktop',
              mobileMessageKey: 'pmwjs_email_editor_page_limit_message_mobile',
            }
          : undefined,
      onAddSelected: onDesignLoaded,
    });
  });
}

/** Single-select design-picker for callers that only need a poster ID + preview URL. */
export function openDesignSelectorLegacy(onDesignLoaded: (id: string, imagePreviewUrl: string | undefined) => void, beforeLoad: VoidFunction = noop): void {
  window.PMW.util.require(typeof window.PMW.designSelector === 'undefined', 'designSelector', true, () => {
    beforeLoad();
    window.PMW.designSelector.open({
      title: window.i18next.t('pmwjs_select_a_design'),
      addSelectedCtaText: window.i18next.t('pmwjs_select'),
      isMultiSelectionAllowed: false,
      addCheckmarkOnSelection: false,
      onAddSelected: (selection: PosterPageData[]): void => {
        if (selection.length > 0) {
          onDesignLoaded(selection[0].posterId, selection[0].previewUrl);
        }
      },
    });
  });
}
